const keyToCamelCase = (origKey: string, convertAcronyms = false) => {
  return convertAcronyms && origKey.toUpperCase() === origKey
    ? origKey.toLowerCase()
    : (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
};

export const toCamelCase = (o: any, convertAcronyms = false) => {
  let newO: any, origKey: any, newKey: any, value: any;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = toCamelCase(value, convertAcronyms);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = keyToCamelCase(origKey, convertAcronyms);
        value = o[origKey];
        if (value instanceof Array || (value && value.constructor === Object)) {
          value = toCamelCase(value, convertAcronyms);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};

export const toPascalCase = (o: any) => {
  let newO: any, origKey: any, newKey: any, value: any;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = toPascalCase(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascalCase(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};
